import { ActionButton, Buttons, CancelButton, Checkbox, Level, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import { accountingProviders } from '~/lookups';
import React, { useState } from 'react';
import styled from 'styled-components';

const P = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

function UnpublishInvoiceDialog({ invoice, resolve }) {
  const { workspace } = useWorkspace();
  const [removeFromAccounting, setRemoveFromAccounting] = useState(false);
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const accountingProviderName = invoice.accountingProvider && accountingProviders[invoice.accountingProvider].name;

  const handleSubmit = async () => {
    form.submit();

    if (removeFromAccounting && accountingProviderName) {
      try {
        await api.www.workspaces(workspace.id).invoices(invoice.id)[`removeFrom${accountingProviderName}`]();
      } catch (error) {
        toast.error(
          error.message ?? `An error has occurred. The invoice has not been removed from ${accountingProviderName}.`,
        );
      }
    }

    await api.www.workspaces(workspace.id).invoices(invoice.id).unpublish();
    await resolve();
    form.save();
    toast.success(`Invoice #${invoice.number} has been unpublished`);
  };

  return (
    <ModalCard title="Unpublish Invoice" onClose={() => resolve(false)}>
      <ModalCard.Body>
        <P>Are you sure you want to unpublish this invoice?</P>
      </ModalCard.Body>

      <ModalCard.Footer>
        <Level>
          {invoice.accountingSynced && accountingProviderName && (
            <Level.Item>
              <Checkbox
                label={`Remove from ${accountingProviderName}`}
                subText={invoice.accountingConnectionName}
                checked={removeFromAccounting}
                onChange={() => setRemoveFromAccounting(!removeFromAccounting)}
              />
            </Level.Item>
          )}

          <Level.Item>
            <Buttons align="right">
              <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
              <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
                Unpublish
              </ActionButton>
            </Buttons>
          </Level.Item>
        </Level>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default UnpublishInvoiceDialog;
